import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseSelectedPromoTable } from './types'

export const useSelectedPromoTable = create<UseSelectedPromoTable>()(
  devtools(
    (set) => ({
      selectedIds: [],
      setSelectedIds: (state) => {
        set((prev) => {
          const selectedIds = typeof state === 'function' ? state(prev.selectedIds) : state
          return { selectedIds }
        })
      },
      clear: () => set({ selectedIds: [] }),
    }),
    {
      store: 'selectedPromoTable',
    },
  ),
)
